import { ProjectTheme } from '../enums/project.enum';
import { TProjectTheme } from '../types/theme.type';

const commonTextStyle = {
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontUrl:
    'https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
  opacity: 1,
};

const baseTheme: Omit<TProjectTheme, 'modeTheme'> = {
  tab: {
    activeTab: '#050505',
    activeTabOpacity: 1,
    inactiveTab: '#050505',
    inactiveTabOpacity: 0.2,
  },
  theme: {
    bgColorButton: {
      primary: '#001264',
      primaryOpacity: 1,
      secondary: '#F04923',
      secondaryOpacity: 1,
    },
    background: {
      color: '#FFFFFF',
      colorOpacity: 1,
      image: undefined,
      imageOpacity: 1,
    },
    container: {
      color: '#050505',
      colorOpacity: 0.06,
    },
    headerRow: {
      color: '#050505',
      colorOpacity: 0.06,
    },
    referralHeroSection: {
      color: '#FFFFFF',
      colorOpacity: 1,
    },
  },
  components: {
    cornerRadius: 4,
  },
  text: {
    heading: {
      ...commonTextStyle,
      color: '#050505',
      fontWeight: 600,
    },
    paragraph: {
      ...commonTextStyle,
      color: '#050505',
      fontWeight: 400,
    },
    subText: {
      ...commonTextStyle,
      color: '#05050533',
      fontWeight: 300,
    },
  },
  image: {
    logo: undefined,
    favicon: undefined,
    featureImage: undefined,
  },
};

export const lightTheme: TProjectTheme = {
  ...baseTheme,
  modeTheme: ProjectTheme.LIGHT,
};

export const darkTheme: TProjectTheme = {
  ...baseTheme,
  modeTheme: ProjectTheme.DARK,
  tab: {
    activeTab: '#FDFDFD',
    activeTabOpacity: 1,
    inactiveTab: '#FDFDFD',
    inactiveTabOpacity: 0.35,
  },
  theme: {
    ...baseTheme.theme,
    background: {
      color: '#14141A',
      colorOpacity: 1,
      image: undefined,
      imageOpacity: 1,
    },
    container: {
      color: '#FDFDFD',
      colorOpacity: 0.12,
    },
    headerRow: {
      color: '#FDFDFD',
      colorOpacity: 0.12,
    },
    referralHeroSection: {
      color: '#FDFDFD',
      colorOpacity: 0.12,
    },
  },
  text: {
    heading: {
      ...commonTextStyle,
      color: '#FDFDFD',
      fontWeight: 600,
    },
    paragraph: {
      ...commonTextStyle,
      color: '#FDFDFD',
      fontWeight: 400,
    },
    subText: {
      ...commonTextStyle,
      color: '#FDFDFD59',
      fontWeight: 300,
    },
  },
};

export const themeMap: Record<ProjectTheme, TProjectTheme> = {
  [ProjectTheme.LIGHT]: lightTheme,
  [ProjectTheme.DARK]: darkTheme,
};
